import dayjs from '../../utils/dayjs';

export interface EventMetadata {
  version: string;
  mobile: boolean;
  timestamp: number;
  account_tier: string | null;
  pipefy_phase: string | null;
}

export class Event {
  name: string;
  description: string;
  group: string;
  category: string;
  action: string;
  label: string;
  value: string;
  created_at: string;
  version: string;
  metadata: EventMetadata;

  constructor(
    name: string,
    version: string,
    isMobile: boolean,
    accountTier: string | null = null,
    pipefyPhase: string | null = null
  ) {
    const metadata: EventMetadata = {
      version,
      mobile: isMobile,
      timestamp: dayjs().unix(),
      account_tier: accountTier,
      pipefy_phase: pipefyPhase
    };

    this.name = name;
    this.description = '';  // legacy
    this.group = '';        // legacy
    this.category = 'user-table';     // legacy
    this.action = '';       // legacy
    this.label = '';        // legacy
    this.value = JSON.stringify(metadata); // legacy
    this.created_at = dayjs().format();
    this.version = version;
    this.metadata = metadata;
  }
}

